import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { Box, media, xcss, Pressable } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	clearIconLabel: string;
	onClear: () => void;
};

export const ClearFieldIcon = ({ onClear, clearIconLabel }: Props) => (
	<Box
		xcss={[fg('jira_jif_jam_clear_text_icon') ? wrapperStylesClearIcon : wrapperStylesCloseIcon]}
	>
		{fg('jira_jif_jam_clear_text_icon') ? (
			<Pressable
				xcss={iconWrapperStyles}
				onClick={onClear}
				// Clear button should not be focusable
				// see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
				tabIndex={-1}
				aria-label={clearIconLabel}
				testId="searchfield.ui.clearfield-icon.clear-button"
			>
				<CrossCircleIcon label="" />
			</Pressable>
		) : (
			<IconButton
				appearance="subtle"
				testId="searchfield.ui.clearfield-icon.clear-button"
				onClick={onClear}
				label={clearIconLabel}
				spacing="compact"
				icon={CrossIcon}
			/>
		)}
	</Box>
);

const wrapperStylesCloseIcon = xcss({
	display: 'flex',
	marginRight: 'space.025',
	[media.above.md]: {
		marginRight: 'space.050',
	},
});

const wrapperStylesClearIcon = xcss({
	display: 'flex',
	marginRight: 'space.050',
	[media.above.md]: {
		marginRight: 'space.075',
	},
});
const iconWrapperStyles = xcss({
	display: 'flex',
	cursor: 'pointer',
	paddingInlineStart: 'space.0',
	paddingInlineEnd: 'space.0',
	paddingBlockStart: 'space.0',
	paddingBlockEnd: 'space.0',
	borderRadius: 'border.radius.circle',
	color: 'color.text.subtlest',
	':hover': {
		color: 'color.text.accent.gray',
	},
});
